// extracted by mini-css-extract-plugin
export default {"title":"pageTitle_title__FaXW6","views":"pageTitle_views__53fVu"};